import { useFormContext } from 'react-hook-form';
import { TextInput } from '@/components/form/TextInput.tsx';
import { CompanyNameFormData } from '@/features/dashboard/company/schemas/companyNameSchema.ts';

const CompanyNameForm = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<CompanyNameFormData>();

  return (
    <TextInput
      label="Nazwa firmy"
      required
      placeholder="Nazwa firmy"
      register={register('companyName')}
      error={errors.companyName?.message}
      hint="Nazwa pojawia się w wiadomościach do uczestników, na fakturach i w panelu zapisów."
    />
  );
};

export default CompanyNameForm;
